import { lazy, Suspense } from 'react';
import { useLocation, type LoaderFunctionArgs } from 'react-router';
import { reviewToken } from '../features/guestReview/model';
import { ModuleLoader } from '../components/loaders/Loaders';

const GuestReviewRoom = lazy(() => import('../features/guestReview/GuestReviewRoom'));
export function reviewLoader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  return { token: reviewToken(url.search, url.hash) };
}
export default function Review() {
  const location = useLocation();
  const token = reviewToken(location.search, location.hash);
  return (
    <Suspense fallback={<ModuleLoader module="guest-review" layout="screen" />}>
      <GuestReviewRoom key={token} token={token} />
    </Suspense>
  );
}
